export default __webpack_public_path__ + "static/media/Banner-N-Laminate.0359b214.jpg";